import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { green, grey, orange } from '@material-ui/core/colors';
import { CheckCircle2, XCircle, PauseCircle } from "lucide-react";

const useStyles = makeStyles(theme => ({
    on: {
        color: green[600],
        fontSize: '20px',
        marginLeft: 5,
    },
    off: {
        color: grey[600],
        fontSize: '20px',
        marginLeft: 5,
    },
    pause: {
        color: orange[600],
        fontSize: '20px',
        marginLeft: 5,
        animation: '$pulse 2s infinite'
    },
    '@keyframes pulse': {
        '0%': {
            opacity: 1,
        },
        '50%': {
            opacity: 0.6,
        },
        '100%': {
            opacity: 1,
        },
    }
}));

const UserStatusIcon = ({ user, size = 20 }) => {
    const classes = useStyles();
    
    // ⏸️ PAUSA: Prioridade máxima - se estiver em pausa, mostrar ícone de pausa
    if (user.pauseMode) {
        return (
            <Tooltip title="Em Pausa (Horário de Almoço/Intervalo)">
                <PauseCircle size={size} className={classes.pause} />
            </Tooltip>
        );
    }
    
    // Online/Offline normal
    return user.online ?
        <Tooltip title="Online">
            <CheckCircle2 size={size} className={classes.on} />
        </Tooltip>
        :
        <Tooltip title="Offline">
            <XCircle size={size} className={classes.off} />
        </Tooltip>
}

export default UserStatusIcon;